/* LE BOUTON « RC » : QUAND PEUT-ON SAISIR LE REGLEMENT COMPTABLE ?

   Le serveur ne l'accepte que sur un reglement technique VALIDE :

       if (parent.getStatut() != StatutPaiement.REGLEMENT_TECHNIQUE_VALIDE)
           throw new BadRequestException(
               "Le reglement comptable ne peut etre saisi qu'apres validation technique...")

   L'ecran raisonnait a l'envers : il desactivait le bouton sur deux statuts - annule, et
   deja regle - et l'ouvrait sur tous les autres. Un lot fraichement cree, donc en
   « EMIS », offrait donc un bouton actif qui ouvrait une modale, faisait saisir un numero
   de cheque et des dates, puis echouait a l'envoi. Le travail de saisie etait perdu, et
   rien n'avait prevenu.

   La regle s'ecrit desormais comme celle du serveur : une liste blanche d'un seul statut.
   Tout nouveau statut ajoute au workflow sera refuse par defaut - c'est le bon sens de la
   garde, et c'est l'inverse de ce qu'elle faisait. */
import i18n from '../../i18n';

/** Le seul statut sur lequel le serveur accepte une saisie comptable. */
export const STATUT_RC_AUTORISE = 'REGLEMENT_TECHNIQUE_VALIDE';

/**
 * L'etat du bouton « RC » pour une ligne de paiement.
 *
 * @param {string} statut le statut du paiement
 * @returns {{autorise: boolean, raison: string}} `raison` est l'infobulle : ce que le
 *   bouton permet quand il est actif, pourquoi il ne l'est pas sinon.
 */
export function etatBoutonRc(statut) {
  if (statut === STATUT_RC_AUTORISE) {
    return { autorise: true, raison: i18n.t('reglementsExperts:boutonRc.saisir') };
  }
  switch (statut) {
    case 'ANNULE':
      return { autorise: false, raison: i18n.t('reglementsExperts:boutonRc.annule') };
    case 'REGLEMENT_COMPTABLE_VALIDE':
    case 'PAYE':
      return {
        autorise: false,
        raison: i18n.t('reglementsExperts:boutonRc.dejaSaisi'),
      };
    case 'EMIS':
    case 'REGLEMENT_TECHNIQUE_SAISI':
      return {
        autorise: false,
        raison: i18n.t('reglementsExperts:boutonRc.attenteTechnique'),
      };
    default:
      /* TOUT STATUT INCONNU EST REFUSE. C'est le sens de la garde : le serveur
         n'acceptera que `REGLEMENT_TECHNIQUE_VALIDE`, et ouvrir le bouton « au cas ou »
         ne ferait que deplacer l'echec apres la saisie. */
      return {
        autorise: false,
        raison: i18n.t('reglementsExperts:boutonRc.impossible'),
      };
  }
}
